import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-new-folder-dialog",
  templateUrl: "./new-folder-dialog.component.html",
  styleUrl: "./new-folder-dialog.component.scss",
})
export class NewFolderDialogComponent {
  @Input() folderDialogContent: any = {};
  @Output() folderDialogActionCall = new EventEmitter<any>();
  newFolderForm!: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.setNewFolderForm();
    }
  }

  setNewFolderForm() {
    this.newFolderForm = this.formBuilder.group({});
    this.folderDialogContent?.formField?.map((field: any) => {
      if (field.model) {
        let validators = [];
        if (field.isRequired) {
          validators.push(Validators.required);
        }
        if (field.maxLength) {
          validators.push(Validators.maxLength(field.maxLength));
        }

        this.newFolderForm.addControl(
          field.model,
          new FormControl(null, validators)
        );
      }
    });
  }

  folderFormAction(btnFlag: boolean = false) {
    let data = {
      actionValue: btnFlag,
      formData: null,
    };
    if (btnFlag) {
      if (!this.newFolderForm.valid) {
        this.newFolderForm.markAllAsTouched();
        return;
      }

      data.formData = this.newFolderForm.getRawValue();
      this.folderDialogActionCall.emit(data);
    } else {
      this.folderDialogActionCall.emit(data);
    }
  }
}
